class DayJSBuilder {
  constructor() {
    this.dayJS = require("dayjs");
    return this;
  }
  advancedFormat() {
    let plugin = require("dayjs/plugin/advancedFormat");
    this.dayJS.extend(plugin);
    return this;
  }
  customParseFormat() {
    let plugin = require("dayjs/plugin/customParseFormat");
    this.dayJS.extend(plugin);
    return this;
  }
  isBetween() {
    let plugin = require("dayjs/plugin/isBetween");
    this.dayJS.extend(plugin);
    return this;
  }
  isSameOrBefore() {
    let plugin = require("dayjs/plugin/isSameOrBefore");
    this.dayJS.extend(plugin);
    return this;
  }
  isSameOrAfter() {
    let plugin = require("dayjs/plugin/isSameOrAfter");
    this.dayJS.extend(plugin);
    return this;
  }
  weekday() {
    let plugin = require("dayjs/plugin/weekday");
    this.dayJS.extend(plugin);
    return this;
  }
  duration() {
    let plugin = require("dayjs/plugin/duration");
    this.dayJS.extend(plugin);
    return this;
  }
  build() {
    return this.dayJS;
  }
}

module.exports = new DayJSBuilder();

// let vanilla = new DayJSBuilder().build();
// console.log(vanilla);

// let dayJS = new DayJSBuilder().addPlugin("advancedFormat").build();

// console.log(dayJS);
